export default __webpack_public_path__ + "static/media/land pooling icon.b0283b3f.svg";